import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import api from "../services/api";

const socket = io(process.env.REACT_APP_API_URL);

export default function DeviceDashboard({ selectedDeviceId }) {
  const [device, setDevice] = useState(null);
  const [animate, setAnimate] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(localStorage.getItem("lastUpdated") || null);

  // fetch actual device data when selected changes
  useEffect(() => {
    const load = async () => {
      if (!selectedDeviceId) {
        setDevice(null);
        return;
      }
      try {
        const res = await api.get(`/device/count/${selectedDeviceId}`);
        setDevice(res.data);
        localStorage.setItem("selectedDevice", selectedDeviceId);
        localStorage.setItem("count", res.data.count);
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, [selectedDeviceId]);

  useEffect(() => {
    socket.on("dataUpdate", (payload) => {
      if (!selectedDeviceId) return;
      if (payload.deviceId === selectedDeviceId) {
        // update device view
        setDevice({ deviceId: payload.deviceId, count: payload.count, limit: payload.limit, status: payload.status });
        setAnimate(true);
        setTimeout(() => setAnimate(false), 400);
        const time = new Date().toLocaleTimeString();
        setLastUpdated(time);
        localStorage.setItem("lastUpdated", time);
      }
    });
    return () => socket.off("dataUpdate");
  }, [selectedDeviceId]);

  const handleReset = async () => {
    if (!selectedDeviceId) return;
    try {
      await api.post(`/devices/reset/${selectedDeviceId}`);
      // fetch again
      const res = await api.get(`/device/count/${selectedDeviceId}`);
      setDevice(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  if (!selectedDeviceId) return <div style={{ padding: 20 }}>Select a device to view dashboard.</div>;

  const count = device ? device.count : 0;
  const limit = device ? device.limit : 10;
  const status = device ? device.status : "No Data";
  const radius = 70, stroke = 8;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const progress = Math.min(count, limit);
  const strokeDashoffset = circumference - (progress / limit) * circumference;
  const statusColor = status === "Authenticated" ? "#4CAF50" : status === "Not Authenticated" ? "#F44336" : "#777";

  return (
    <div style={{ background: "#fff", padding: 20, borderRadius: 8, maxWidth: 420, boxShadow: "0 5px 15px rgba(0,0,0,0.05)" }}>
      <h3 style={{ marginTop: 0 }}>Live: {selectedDeviceId}</h3>

      <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
        <svg height={radius * 2} width={radius * 2}>
          <circle stroke="#e0e0e0" fill="transparent" strokeWidth={stroke} r={normalizedRadius} cx={radius} cy={radius} />
          <circle stroke={statusColor} fill="transparent" strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={`${circumference} ${circumference}`}
            style={{ strokeDashoffset, transition: "stroke-dashoffset 0.5s ease" }}
            r={normalizedRadius} cx={radius} cy={radius} />
          <text x="50%" y="50%" dy="0.3em" textAnchor="middle" fontSize="20px" fill="#333">{count}/{limit}</text>
        </svg>

        <div>
          <div style={{ marginBottom: 8 }}>
            <strong>Status:</strong> <span style={{ color: statusColor }}>{status}</span>
          </div>
          <div style={{ marginBottom: 8 }}>
            <button onClick={handleReset} style={{ padding: "8px 12px" , background: "#f44336", color: "#fff", border: "none", borderRadius: "4px" }}>Reset Device</button>
          </div>
          {lastUpdated && <div style={{ color: "#777", fontSize: 12 }}>Last updated: {lastUpdated}</div>}
        </div>
      </div>
    </div>
  );
}
